<template>
  <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
    <a-row>
      <a-col :span="8">
        <a-form-item label="消息类型组">
          <a-select
            v-model:value="params.groupCodes"
            mode="tags"
            placeholder="请选择消息类型组"
            :options="messageTypeGroups"
          ></a-select>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="消息类型名称">
          <a-input
            v-model:value="params.messageTypeName"
            placeholder="请输入消息名称"
          ></a-input>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <div style="text-align: right;">
          <a-button type="primary" class="mr10" @click="changePage(1)"
            >查询
          </a-button>
          <a-button @click="setEmpty()">重置</a-button>
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="20">
        <div style="padding: 8px 0">
          <a-button type="primary" class="mr10" @click="showMessageGroup()"
            >消息类型组
          </a-button>
          <a-button type="primary" class="mr10" @click="showDraw(null)"
            >新增
          </a-button>
        </div>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { inject, toRefs } from 'vue'

export default {
  name: 'SiteMessageSearch',
  setup() {
    const state = inject('state')

    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      ...toRefs(state)
    }
  }
}
</script>

<style scoped></style>
